import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./meanmenu.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import logo from "../../../assets/images/logo.png";

const MobileOffcanvas = ({ isOpen, onClose }) => {
  const [openSubmenus, setOpenSubmenus] = useState({});
  const navigate = useNavigate();

  const toggleSubmenu = (index) => {
    setOpenSubmenus((prevOpenSubmenus) => ({
      ...prevOpenSubmenus,
      [index]: !prevOpenSubmenus[index],
    }));
  };

  const handleMegaMenuClick = (path, sectionId) => {
    navigate(`${path}?tab=${sectionId}`, { state: { sectionId } });
    onClose();
  };

  return (
    <div
      className={`offcanvas offcanvas-start ${isOpen ? "open" : ""}`}
      tabindex="-1"
      id="offcanvasExample"
      aria-labelledby="offcanvasExampleLabel">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasExampleLabel">
          <Link exact to="/" className="offcanvas_logo">
            <img src={logo} alt="" />
          </Link>
        </h5>
        <button
          type="button"
          class="btn-close btn-close-white"
          onClick={onClose}
          data-bs-dismiss="offcanvas"
          aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
        <ul className="offcanvas_list">
          <li>
            <Link exact to="/" className="offcanvas_link">
              Home
            </Link>
          </li>
          <li>
            <Link exact to="/About" className="offcanvas_link">
              About
            </Link>
          </li>
          <li>
            <Link className="offcanvas_link">Services</Link>
            <button className="toggle-button" onClick={() => toggleSubmenu(1)}>
              {openSubmenus[1] ? "-" : "+"}
            </button>
            <ul className={`submenu ${openSubmenus[1] ? "open" : ""}`}>
              <li className="border-0">
                <Link
                  exact
                  to="/DigitalEngineeringServiceList"
                  className="offcanvas_link">
                  Digital Engineering
                </Link>
                <button
                  className="toggle-button"
                  onClick={() => toggleSubmenu(2)}>
                  {openSubmenus[2] ? "-" : "+"}
                </button>
                <ul className={`submenu ${openSubmenus[2] ? "open" : ""}`}>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "advanced-fea-cfd-simulation"
                        )
                      }
                      className="offcanvas_link">
                      Advanced FEA/CFD Simulation
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "manufacturing-process-simulation"
                        )
                      }
                      className="offcanvas_link">
                      Manufacturing Process Simulation
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "infuse-ai-ml-into-cad-cae-automation"
                        )
                      }
                      className="offcanvas_link">
                      Infuse AI/ML into CAD/CAE Automation
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "structural-engineering-pe-stamping"
                        )
                      }
                      className="offcanvas_link">
                      Structural Engineering PE Stamping
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "mechanical-pe-stamping"
                        )
                      }
                      className="offcanvas_link">
                      Mechanical PE Stamping
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "seismic-pe-stamping"
                        )
                      }
                      className="offcanvas_link">
                      Seismic PE stamping
                    </a>
                  </li>

                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "product-design-engineering"
                        )
                      }
                      className="offcanvas_link">
                      Product Design Engineering
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "product-lifecyle-management"
                        )
                      }
                      className="offcanvas_link">
                      Product Lifecyle Management
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "system-design-and-engineering"
                        )
                      }
                      className="offcanvas_link">
                      System Design and Engineering
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "cad-migration-services"
                        )
                      }
                      className="offcanvas_link">
                      CAD Migration Services
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "manufacturing-engineering"
                        )
                      }
                      className="offcanvas_link">
                      Manufacturing Engineering
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "digital-transformation"
                        )
                      }
                      className="offcanvas_link">
                      Digital Transformation
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "robotic-process-automation-rpa"
                        )
                      }
                      className="offcanvas_link">
                      Robotic Process Automation (RPA)
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "augmented-reality-and-virtual-reality"
                        )
                      }
                      className="offcanvas_link">
                      Augmented Reality and Virtual Reality
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/DigitalEngineeringService",
                          "cybersecurity"
                        )
                      }
                      className="offcanvas_link">
                      Cybersecurity
                    </a>
                  </li>
                </ul>
              </li>
              <li className="border-0">
                <Link
                  exact
                  to="/AIMLComputerVisionList"
                  className="offcanvas_link">
                  Ai/ml & Computer Vision
                </Link>
                <button
                  className="toggle-button"
                  onClick={() => toggleSubmenu(3)}>
                  {openSubmenus[3] ? "-" : "+"}
                </button>
                <ul className={`submenu ${openSubmenus[3] ? "open" : ""}`}>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "data-analytics-and-machine-learning"
                        )
                      }
                      className="offcanvas_link">
                      Data Analytics and Machine Learning
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "predictive-analytics"
                        )
                      }
                      className="offcanvas_link">
                      Predictive Analytics
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "big-data-solutions"
                        )
                      }
                      className="offcanvas_link">
                      Big Data Solutions
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "data-preparation-and-management"
                        )
                      }
                      className="offcanvas_link">
                      Data Preparation and Management
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "natural-language-processing-nlp"
                        )
                      }
                      className="offcanvas_link">
                      NLP
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "computer-vision"
                        )
                      }
                      className="offcanvas_link">
                      Computer Vision
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "automated-inspection"
                        )
                      }
                      className="offcanvas_link">
                      Automated Inspection
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "machine-vision"
                        )
                      }
                      className="offcanvas_link">
                      Machine Vision
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "smart-camera-vision-system"
                        )
                      }
                      className="offcanvas_link">
                      Smart Camera Vision System
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "pc-based-vision-system"
                        )
                      }
                      className="offcanvas_link">
                      PC Based Vision System
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "vision-s-w-development"
                        )
                      }
                      className="offcanvas_link">
                      Vision S/w Development
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/AIMLComputerVisionDetail",
                          "lighting-and-optics-design"
                        )
                      }
                      className="offcanvas_link">
                      Lighting and Optics Design
                    </a>
                  </li>
                </ul>
              </li>
              <li className="border-0">
                <Link exact to="/AIDataServicesList" className="offcanvas_link">
                  Ai Data Services
                </Link>
                <button
                  className="toggle-button"
                  onClick={() => toggleSubmenu(4)}>
                  {openSubmenus[4] ? "-" : "+"}
                </button>
                <ul className={`submenu ${openSubmenus[4] ? "open" : ""}`}>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick("/AIDataServicesList?tab=1")
                      }
                      className="offcanvas_link">
                      ADAS Data Annotation & Labeling
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick("/AIDataServicesList?tab=2")
                      }
                      className="offcanvas_link">
                      Data Collection
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick("/AIDataServicesList?tab=3")
                      }
                      className="offcanvas_link">
                      Data Anonymization
                    </a>
                  </li>
                </ul>
              </li>
              <li className="border-0">
                <Link exact to="/CloudServiceList" className="offcanvas_link">
                  Cloud Services
                </Link>
                <button
                  className="toggle-button"
                  onClick={() => toggleSubmenu(5)}>
                  {openSubmenus[5] ? "-" : "+"}
                </button>
                <ul className={`submenu ${openSubmenus[5] ? "open" : ""}`}>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/CloudServiceDetail",
                          "platform-as-a-service-paas"
                        )
                      }
                      className="offcanvas_link">
                      Platform as a Service (PaaS)
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/CloudServiceDetail",
                          "software-as-a-service-saas"
                        )
                      }
                      className="offcanvas_link">
                      Software as a Service (SaaS)
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/CloudServiceDetail",
                          "cloud-storage-and-content-delivery"
                        )
                      }
                      className="offcanvas_link">
                      Cloud Storage and Content Delivery
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/CloudServiceDetail",
                          "data-analytics"
                        )
                      }
                      className="offcanvas_link">
                      Data Analytics
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/CloudServiceDetail",
                          "security-and-identity-management"
                        )
                      }
                      className="offcanvas_link">
                      Security and Identity Management
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/CloudServiceDetail",
                          "cloud-migration-and-management"
                        )
                      }
                      className="offcanvas_link">
                      Cloud Migration and Management
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/CloudServiceDetail",
                          "cloud-contact-center"
                        )
                      }
                      className="offcanvas_link">
                      Cloud Contact Center
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/CloudServiceDetail",
                          "ux-ui-design"
                        )
                      }
                      className="offcanvas_link">
                      UX/UI Design
                    </a>
                  </li>
                </ul>
              </li>
              <li className="border-0">
                <Link exact to="/SapServiceList" className="offcanvas_link">
                  SAP Services
                </Link>
                <button
                  className="toggle-button"
                  onClick={() => toggleSubmenu(6)}>
                  {openSubmenus[6] ? "-" : "+"}
                </button>
                <ul className={`submenu ${openSubmenus[6] ? "open" : ""}`}>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick("/SapServiceDetail", "sap-s-4hana")
                      }
                      className="offcanvas_link">
                      SAP S/4HANA
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/SapServiceDetail",
                          "sap-business-technology-platform"
                        )
                      }
                      className="offcanvas_link">
                      SAP Business Technology Platform (BTP)
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick("/SapServiceDetail", "sap-ariba")
                      }
                      className="offcanvas_link">
                      SAP Ariba
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/SapServiceDetail",
                          "sap-digital-supply-chain"
                        )
                      }
                      className="offcanvas_link">
                      SAP Digital Supply Chain
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/SapServiceDetail",
                          "sap-financial-services"
                        )
                      }
                      className="offcanvas_link">
                      SAP Financial Services
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/SapServiceDetail",
                          "sap-customer-experience-cx"
                        )
                      }
                      className="offcanvas_link">
                      SAP Customer Experience (CX)
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/SapServiceDetail",
                          "sap-cloud-platform"
                        )
                      }
                      className="offcanvas_link">
                      SAP Cloud Platform
                    </a>
                  </li>
                </ul>
              </li>
              <li className="border-0">
                <Link
                  exact
                  to="/ElectronicsEmbededList"
                  className="offcanvas_link">
                  Electronics & Embedded Design
                </Link>
                <button
                  className="toggle-button"
                  onClick={() => toggleSubmenu(7)}>
                  {openSubmenus[7] ? "-" : "+"}
                </button>
                <ul className={`submenu ${openSubmenus[7] ? "open" : ""}`}>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/ElectronicsEmbededDetail",
                          "firmware-design"
                        )
                      }
                      className="offcanvas_link">
                      Firmware Design
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/ElectronicsEmbededDetail",
                          "embedded-software-development"
                        )
                      }
                      className="offcanvas_link">
                      Embedded Software Development
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/ElectronicsEmbededDetail",
                          "system-integration-and-testing"
                        )
                      }
                      className="offcanvas_link">
                      System Integration and Testing
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/ElectronicsEmbededDetail",
                          "hmi-design"
                        )
                      }
                      className="offcanvas_link">
                      HMI design
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/ElectronicsEmbededDetail",
                          "pcb-design-fabricating"
                        )
                      }
                      className="offcanvas_link">
                      PCB Design & fabricating
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/ElectronicsEmbededDetail",
                          "antena-design"
                        )
                      }
                      className="offcanvas_link">
                      Antena Design
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/ElectronicsEmbededDetail",
                          "rf-wireless-design"
                        )
                      }
                      className="offcanvas_link">
                      RF/Wireless Design
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/ElectronicsEmbededDetail",
                          "system-modeling"
                        )
                      }
                      className="offcanvas_link">
                      System Modeling
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/ElectronicsEmbededDetail",
                          "system-integration"
                        )
                      }
                      className="offcanvas_link">
                      System Integration
                    </a>
                  </li>
                  <li class="mega-item">
                    <a
                      onClick={() =>
                        handleMegaMenuClick(
                          "/ElectronicsEmbededDetail",
                          "cable-harness"
                        )
                      }
                      className="offcanvas_link">
                      Cable Harness
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <Link exact to="/Industry" className="offcanvas_link">
              Industry
            </Link>
          </li>
          <li>
            <Link exact to="/Insights" className="offcanvas_link">
              Insights
            </Link>
          </li>
          <li>
            <Link exact to="/Careers" className="offcanvas_link">
              Careers
            </Link>
          </li>
          <li>
            <Link exact to="/" className="offcanvas_link">
              Testimonial
            </Link>
          </li>
          <li>
            <Link
              onClick={() => window.scrollTo(0, 0)}
              exact
              to="/NewsList"
              className="offcanvas_link">
              News
            </Link>
          </li>
          <li>
            <Link
              onClick={() => window.scrollTo(0, 0)}
              exact
              to="/Blog"
              className="offcanvas_link">
              Blog
            </Link>
          </li>
          <li>
            <a
              onClick={() => {
                onClose();
                window.open("http://16.16.179.42/", "_blank", "noopener,noreferrer");
              }}
              className="offcanvas_link">
              IT Support
            </a>
          </li>
          <li>
            <Link
              onClick={() => window.scrollTo(0, 0)}
              exact
              to="/CSR"
              className="offcanvas_link">
              CSR
            </Link>
          </li>
          {/* <li>
            <Link exact to="/ITITES" className="offcanvas_link">
              IT/IT ES
            </Link>
          </li> */}
          <li>
            <Link exact to="/Contact" className="offcanvas_link">
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MobileOffcanvas;
